import React, { useEffect, useState } from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { maxbbox } from "./areaConstants";
import { selectOptions } from '../js/utilityRoutines';

export default function SubstateSelect(props) {
	const { userParams, setUserParams, postals, otherType } = props;
    const [selectedIndex, setSelectedIndex] = useState();
    const [areas, setAreas] = useState();
    const [fetchError, setFetchError] = useState();
	const [loading, setLoading] = useState(false);

	const handleMenuClick = (event) => {
        const index = event.target.value;
		setSelectedIndex(index);
        let bbox = areas[index].bbox;
        bbox = checkBbox(bbox);
		setUserParams({...userParams, areaType: "bbox", area: bbox.join(',')});
	};

    // check bounding box 
    const checkBbox = bbox => {
        const newbbox = [...bbox]
        if (bbox[0] < maxbbox.west) {
            newbbox[0] = maxbbox.west;
        }
        if (bbox[1] < maxbbox.south) {
            newbbox[1] = maxbbox.south;
        }
        if (bbox[2] > maxbbox.east) {
            newbbox[2] = maxbbox.east;
        }
        if (bbox[3] > maxbbox.north) {
            newbbox[3] = maxbbox.north;
        }
        return newbbox;
    };
    
    // format response for dropdown menu and select first item
    const formatResponse = response => {
        const newAreas = [];
        response.meta.forEach((area, i) => {
            newAreas.push({
                value: i,
                label: area.name.replace(/County|Parish/,""),
                bbox: area.bbox
            })
        })
        setAreas(newAreas);
        setSelectedIndex(0);
        let bbox = newAreas[0].bbox;
        bbox = checkBbox(bbox);
        setUserParams({...userParams, areaType: "bbox", area: bbox.join(',')});
    };

    // get areas in selected state
    const fetchGeneral = () => {
        if (postals.length >= 2) {
            setLoading(true);
            const options = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ state: postals, meta: "name,id,bbox" })
            };
            const url = "https://data.rcc-acis.org/General/" + otherType;
            fetch(url, options)
                .then(response => {
                    if (!response.ok) {
                        setFetchError("Error fetching the list");
                        return;
                    }
                    return response.json()
                })
                .then(response => {
                    if (response.meta && response.meta.length) {
                        formatResponse(response)
                    } else {
                        setFetchError("No list available for " + postals);
                    }
                })
                .catch(err => {
                    if (err.message.includes("Failed to execute 'createObjectURL' on 'URL'")) {
                        setFetchError("Invalid request");
                    } else {
                        setFetchError(err.message);
                    };
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setFetchError("Enter state postal abbreviation above");
        }
    };

    useEffect(() => {
		// Reset 
		setFetchError(null);
        setAreas(null);
        // Get list
        fetchGeneral();
	}, [ postals, otherType ]);
	
	return (
        <>
            {areas &&
                <TextField
                    select
                    name="area"
                    label={otherType[0].toUpperCase() + otherType.slice(1)}
                    value={selectedIndex}
                    onChange={handleMenuClick}
                >
                    {selectOptions(areas)}
                </TextField>
            }
            {loading &&
                <Stack direction="row" spacing={2} sx={{ mt: 0 }}>
                    <CircularProgress size="1em" />
                    <Typography variant="body2"sx={{ textAlign: "center", mt: "0!important" }}>Loading</Typography>
                </Stack>
            }
            {fetchError &&
               <Typography variant="body2" sx={{ color: "red", textAlign: "center", mt: "0!important"}}>{fetchError}</Typography>
            }
        </>
    )
 };